const MY_PAGE_PATH = "/main/mypage";
const DEVICE_STATUS_PATH = "/main/deviceStatus";
const DEVICE_MANAGEMENT_PATH = "/main/device";
const ALARM_MANAGEMENT_PATH = "/main/alarm";
const ADMIN_MANAGEMENT_PATH = "/main/admin";
const SYSTEM_MANAGEMENT_PATH = "/main/settings";

export const path = [
    { id: "1", path: MY_PAGE_PATH, label: "마이페이지", auth: "USER" },
    { id: "2", path: DEVICE_STATUS_PATH, label: "장비 현황", auth: "USER" },
    { id: "3", path: DEVICE_MANAGEMENT_PATH, label: "장비 관리", auth: "SYSTEM" },
    { id: "4", path: ADMIN_MANAGEMENT_PATH, label: "관리자 관리", auth: "SYSTEM" },
    { id: "5", path: ALARM_MANAGEMENT_PATH, label: "알림 관리", auth: "SYSTEM" },
    { id: "6", path: SYSTEM_MANAGEMENT_PATH, label: "시스템 관리", auth: "SYSTEM" },
];
  
  export default path;